import { NavLink } from "react-router-dom";
import { useState } from "react";
import { LinkList, Logout, LogoWrapper } from "./style";
//mui
import HelpOutlineSharpIcon from "@mui/icons-material/HelpOutlineSharp";
import SettingsSharpIcon from "@mui/icons-material/SettingsSharp";
import ColumnContainer from "../../common/ColumnContainer";

//utils
import useWindowDimensions from "../../../utils/useMediaQuery";
import {
  GridView,
  LogoutRounded,
  PortraitRounded,
  SpeakerNotesRounded,
} from "@mui/icons-material";
import GroupIcon from "@mui/icons-material/Group";
import WorkRoundedIcon from "@mui/icons-material/WorkRounded";

import {
  adminDashboardRoute,
  commonRoutes,
  userDashboardRoute,
} from "../../../utils/routes/Routes";
import LanguageDropdown from "../../common/LanguageDropdown";
import logoImage from "../../../assets/logo1.png";
import { FormattedMessage } from "react-intl";
import InternalSideBar from "./InternalSideBar";

export default function LinksSideBar({ handleLogout, open, userProfileData }) {
  const { width } = useWindowDimensions();

  const role = userProfileData?.role || ""; // Assicurati che role abbia un valore di fallback

  const secondaryUrls = [
    {
      icon: <SettingsSharpIcon />,
      path: adminDashboardRoute.settings,
      label: <FormattedMessage id="dashboard.sidebar.settings" />,
      role: ["admin"],
    },
    {
      icon: <HelpOutlineSharpIcon />,
      path: userDashboardRoute.faq,
      label: <FormattedMessage id="dashboard.sidebar.support" />,
      role: ["user"],
    },
    {
      icon: <HelpOutlineSharpIcon />,
      path: adminDashboardRoute.faq,
      label: <FormattedMessage id="dashboard.sidebar.support" />,
      role: ["admin"],
    },
  ];

  let isDesktop = width > 1200 ? true : false;

  const sideBarItemList = [
    {
      icon: <GridView />,
      path: adminDashboardRoute.dashboardHome,
      label: <FormattedMessage id="dashboard.sidebar.dashboard" />,
      role: ["admin"],
    },
    {
      icon: <GridView />,
      path: userDashboardRoute.dashboardHome,
      label: <FormattedMessage id="dashboard.sidebar.dashboard" />,
      role: ["user"],
    },

    {
      icon: <GroupIcon />,
      path: adminDashboardRoute.users,
      label: <FormattedMessage id="dashboard.sidebar.users" />,
      role: ["admin"],
    },
    {
      icon: <SpeakerNotesRounded />,
      path: adminDashboardRoute.tickets,
      label: <FormattedMessage id="dashboard.sidebar.tickets" />,
      role: ["admin"],
    },
    {
      icon: <WorkRoundedIcon />,
      path: userDashboardRoute.projects,
      label: <FormattedMessage id="dashboard.sidebar.operations" />,
      role: ["user"],
    },
    {
      icon: <SpeakerNotesRounded />,
      path: userDashboardRoute.tickets,
      label: <FormattedMessage id="dashboard.sidebar.tickets" />,
      role: ["user"],
    },
    {
      icon: <PortraitRounded />,
      path: adminDashboardRoute.profile,
      label: <FormattedMessage id="dashboard.sidebar.profile" />,
      role: ["admin"],
    },
    {
      icon: <PortraitRounded />,
      path: userDashboardRoute.profile,
      label: <FormattedMessage id="dashboard.sidebar.profile" />,
      role: ["user"],
    },
  ];

  return (
    <ColumnContainer align="start" padding={"20px"}>
      <ColumnContainer align="start">
        <LogoWrapper logoImage={logoImage} />
        <LinkList open={open} className={isDesktop ? "padding1" : "padding2"}>
          <div>
            {sideBarItemList.map(
              (item, index) =>
                !!role &&
                item.role.includes(role) && (
                  <NavLink
                    className="not-underlined"
                    key={index}
                    to={item.path}
                  >
                    {item.icon}
                    {isDesktop && item.label}
                  </NavLink>
                )
            )}

            <div className="settings">
              <hr></hr>
              {secondaryUrls?.map(
                (secondaryUrl, ind) =>
                  !!role &&
                  secondaryUrl.role.includes(role) && (
                    <NavLink
                      className="not-underlined"
                      key={ind}
                      to={secondaryUrl.path}
                    >
                      {secondaryUrl.icon}
                      {isDesktop && <p>{secondaryUrl.label}</p>}
                    </NavLink>
                  )
              )}
            </div>
            <LanguageDropdown dashboardColors={true} />
          </div>
        </LinkList>
      </ColumnContainer>
      <Logout onClick={(e) => handleLogout(e)}>
        <LogoutRounded />
        {isDesktop && (
          <p>
            <FormattedMessage id="dashboard.sidebar.logout" />
          </p>
        )}
      </Logout>
    </ColumnContainer>
  );
}
